import React, { useState } from "react";

const DeleteData: React.FC = () => {
  const [password, setPassword] = useState("");
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsConsentChecked(e.target.checked);
  };

  const handleDeleteData = () => {
    if (!password) {
      alert("Please enter your password to proceed.");
      return;
    }

    if (!isConsentChecked) {
      alert("Please confirm your consent before proceeding.");
      return;
    }

    // Add your delete data API call logic here
    console.log("User data deleted");
    alert("Your data deletion request has been submitted.");
  };

  return (
    <div className="flex justify-center items-center mb-4 mt-4">
      {/* Delete Data Section */}
      <div className="w-3/4 pl-6">
        <h1 className="text-2xl font-bold mb-4">Delete Your Data</h1>
        <p className="mb-6 text-gray-600">
          Deleting your data will permanently remove all your personal
          information and purchase history from our system. This action is
          irreversible. Please proceed with caution.
        </p>
        <form className="space-y-4">
          {/* Password Input */}
          <div>
            <label htmlFor="password" className="block font-medium">
              Confirm Password <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              id="password"
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Enter your current password"
              value={password}
              onChange={handlePasswordChange}
            />
          </div>

          {/* Consent Checkbox */}
          <div>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={isConsentChecked}
                onChange={handleConsentChange}
                className="mr-2"
              />
              <span>
                I understand that deleting my data is irreversible and all
                information will be permanently removed.
              </span>
            </label>
          </div>

          {/* Delete Button */}
          <button
            type="button"
            onClick={handleDeleteData}
            className="bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700"
          >
            Delete My Data
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeleteData;
